module.exports = __webpack_public_path__ + "static/media/preview_chart_1_liveprofile.945e71c4.jpg";